<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <agentVendorShop @select="selectHandler" />

      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="couponid" label="优惠券编号"></el-table-column>
      <el-table-column prop="couponName" label="优惠券名称"></el-table-column>
      <el-table-column label="优惠券类型">
        <template slot-scope="scope">{{
          scope.row.type | filterType
        }}</template>
      </el-table-column>
      <el-table-column label="优惠券产品">
        <template slot-scope="scope">{{
          scope.row.limitedProductType | filterProductType
        }}</template>
      </el-table-column>
      <el-table-column label="抵价券数额/折扣率(%)">
        <template slot-scope="scope">{{ getCouponVal(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="count" label="优惠券数量"></el-table-column>
      <el-table-column prop="usedCount" label="已使用数量"></el-table-column>
      <el-table-column label="门店">
        <template slot-scope="scope">
          {{ getShopsInStrings(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column label="有效日期">
        <template slot-scope="scope">
          {{ scope.row.startDate | formatDateTime }} ~
          {{ scope.row.expireDate | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="加盟商">
        <template slot-scope="scope">{{
          getCouponVendorName(scope.row.vendorid)
        }}</template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @after-enter="setActiveItem(scope.row.couponid)"
            @click="handleAssign(scope.row)"
            >分配</el-button
          >
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <EditDialog
      v-if="isDialogShow"
      :isCreate="isCreate"
      :couponItem="couponItem"
      @closeForm="closeForm"
      @refreshData="onSubmit"
    />

    <el-dialog
      :title="'分配'"
      :visible="true"
      v-if="isShowAssign"
      width="30%"
      :couponItem="couponItem"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="handleCloseFP"
    >
      <el-form
        ref="ruleForm"
        :v-model="assignModel"
        label-width="120px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="20">
            <el-form-item label="优惠券名称" prop="couponName">
              <span>{{ couponItem.couponName }}</span>
            </el-form-item>
            <el-form-item label="手机号(多个手机用,分割)" prop="userMobiles">
              <el-input
                type="textarea"
                placeholder="请输入手机号,(多个手机用,分割)"
                :rows="3"
                v-model.trim="assignModel.userMobiles"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="align-center">
          <el-button type="primary" @click="confirmAssign(couponItem.couponid)"
            >确定</el-button
          >
          <el-button @click="closeForm()">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import agentVendorShop from "@/components/layout/agentVendorShop";
import EditDialog from "./components/editDialog";
import Coupon from "../../plugins/CouponClass";
//import { mapGetters } from "vuex";
export default {
  components: {
    agentVendorShop,
    EditDialog
  },
  data() {
    return {
      formInline: {
        vendorid: undefined,
        shopid: undefined,
        vendorName: "",
        shopName: ""
      },
      isShowAssign: false,
      isDialogShow: false,
      isCreate: true,
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      assignModel: {
        couponid: 0,
        userMobiles: []
      },
      tableData: [],
      // vendorsList: [],
      // shopList: [],
      couponItem: null,

      dynamicValidateForm: {
        userMobiles: [
          {
            value: ""
          }
        ]
      },

      selectedCouponid: ""
    };
  },

  filters: {
    filterProductType(val) {
      return Coupon.limitedProductTypeList().find(ele => ele.id === val).name;
    },
    filterType(val) {
      return Coupon.typeList().find(ele => ele.id === val).name;
    }
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.formInline.agentid = x.selectedAgent.agentid;
      this.formInline.vendorid = x.selectedVendor.vendorid;
      this.formInline.machineInShopid = x.selectedShop.shopid;
    },
    handleCloseFP() {
      this.isShowAssign = false;
    },
    onAdd() {
      this.isCreate = true;
      this.isDialogShow = true;
    },
    handleEdit(item) {
      this.couponItem = item;
      this.isCreate = false;
      this.isDialogShow = true;
    },
    handleAssign(item) {
      console.log("handleAssign");
      this.couponItem = item;
      this.isShowAssign = true;
      this.assignModel = {};
    },
    onSubmit() {
      this.queryCoupon();
    },
    closeForm() {
      this.isDialogShow = false;
      this.isShowAssign = false;
    },
    queryCoupon() {
      this.$axios(this.$urlMapping["查询优惠券"], {
        data: {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          ...this.formInline
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    // filterVendor(vendorid) {
    //   let vendorNameItem = this.vendorsList.find(
    //     ele => ele && ele.vendorid === vendorid
    //   );
    //   if (vendorNameItem) {
    //     return vendorNameItem.vendorName;
    //   } else {
    //     return "无效的vendor【" + vendorid + "】";
    //   }
    // },
    handleDelete(item) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let couponids = [item.couponid];
        this.$axios(this.$urlMapping["删除优惠券"], {
          data: {
            couponids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    getCouponVal(item) {
      if (item.type === 1) {
        return `抵用券${item.discountAmount}元`;
      } else {
        return `折扣率${item.zhekou}%`;
      }
    },
    handleShare(item) {
      console.log(item);
    },
    removeUsername(item) {
      var index = this.dynamicValidateForm.userMobiles.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.userMobiles.splice(index, 1);
      }
    },
    addUsername() {
      this.dynamicValidateForm.userMobiles.push({
        value: ""
      });
    },
    resetUsername() {
      this.dynamicValidateForm = {
        userMobiles: [
          {
            value: ""
          }
        ]
      };
    },
    confirmAssign(couponid) {
      this.assignModel.couponid = couponid;
      var patt = new RegExp(/^(\d{11},)*\d{11}$/);
      if (!patt.test(this.assignModel.userMobiles)) {
        this.$notify.error({
          title: "错误",
          message: "请输入正确的手机号"
        });
        return;
      }

      this.assignModel.userMobiles = this.assignModel.userMobiles.split(",");
      this.$axios(this.$urlMapping["分配优惠券"], {
        data: this.assignModel
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        this.$notifySuccess();
        /*错误弹窗 */
      });
    },
    setActiveItem(couponid) {
      //this.selectedCouponid = couponid;
      this.assignModel.couponid = couponid;
    },
    getShopsInStrings(row) {
      //console.log("getShopsInStrings", row.shops);
      let list = [];
      if (row.vendorid == "global") {
        return "全局";
      } else {
        if (row.shops) {
          row.shops.forEach(ele => {
            list = list.concat(Object.values(ele));
          });
          return list.join(",");
        } else {
          return "";
        }
      }
    },

    getCouponVendorName(vendorid) {
      if (vendorid == "global") {
        return "全局";
      } else {
        return this.$getVendorName(vendorid);
      }
    }
  },

  async mounted() {
    this.queryCoupon();
  }
};
</script>

<style lang="less" scoped></style>
